import {
  CloseIcon,
  DownloadIcon,
  FileAttachmentPreviewProps,
  LoadingIndicatorIcon,
  RetryIcon,
  useTranslationContext,
} from 'stream-chat-react';
import { Paperclip } from 'lucide-react';
import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { PdfViewer } from '@/components/pdf-viewer/pdf-viewer';

export const PdfAttachmentPreview = ({
  attachment,
  handleRetry,
  removeAttachments,
}: FileAttachmentPreviewProps) => {
  const { t } = useTranslationContext('FilePreview');
  const uploadState = attachment.localMetadata?.uploadState;
  const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);

  return (
    <>
      <div
        className="str-chat__attachment-preview-file"
        data-testid="attachment-preview-file"
        onClick={() => {
          if (attachment.localMetadata?.uploadState === 'finished' && !!attachment.asset_url) {
            setIsPdfDialogOpen(true);
          }
        }}
      >
        <div className="str-chat__attachment-preview-file-icon h-4 w-4">
          <Paperclip className="h-4 w-4" />
        </div>

        <button
          aria-label={t('aria/Remove attachment')}
          className="str-chat__attachment-preview-delete"
          data-testid="file-preview-item-delete-button"
          disabled={uploadState === 'uploading'}
          onClick={() =>
            attachment.localMetadata?.id && removeAttachments([attachment.localMetadata?.id])
          }
        >
          <CloseIcon />
        </button>

        {['blocked', 'failed'].includes(uploadState) && !!handleRetry && (
          <button
            className="str-chat__attachment-preview-error str-chat__attachment-preview-error-file"
            data-testid="file-preview-item-retry-button"
            onClick={() => {
              handleRetry(attachment);
            }}
          >
            <RetryIcon />
          </button>
        )}

        <div className="str-chat__attachment-preview-file-end">
          <div className="str-chat__attachment-preview-file-name" title={attachment.title}>
            {attachment.title}
          </div>
          {/* undefined if loaded from a draft */}
          {(typeof uploadState === 'undefined' || uploadState === 'finished') &&
            !!attachment.asset_url && (
              <a
                aria-label={t('aria/Download attachment')}
                className="str-chat__attachment-preview-file-download"
                download
                href={attachment.asset_url}
                rel="noreferrer"
                target="_blank"
                title={t('Download attachment {{ name }}', { name: attachment.title })}
              >
                <DownloadIcon />
              </a>
            )}
          {uploadState === 'uploading' && <LoadingIndicatorIcon size={17} />}
        </div>
      </div>
      <Dialog open={isPdfDialogOpen} onOpenChange={setIsPdfDialogOpen}>
        <DialogContent className="min-w-[75vw] h-[97vh] p-10">
          <PdfViewer pdfUrl={attachment.asset_url!} />
        </DialogContent>
      </Dialog>
    </>
  );
};
